module.exports = __webpack_public_path__ + "static/media/21_tn.ca1c27e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/boulders/thumbnails/21_tn.jpg
// module id = 451
// module chunks = 0